import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import ServicePage from "./pages/ServicePage";
import InsightPage from "./pages/InsightPage";
import BuiltViewshift from "./pages/BuiltViewshift";
import OgPreview from "./pages/OgPreview";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/insights/:slug" element={<InsightPage />} />
          <Route path="/built/viewshift" element={<BuiltViewshift />} />
          <Route path="/og-preview" element={<OgPreview />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}

export default App;
